import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check-all--sprite",
  "use": "check-all--sprite-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"check-all--sprite\">\n    <path d=\"M0.410156 13.4101L6.00016 19.0001L7.41016 17.5801L1.83016 12.0001L0.410156 13.4101ZM22.2402 5.58008L11.6602 16.1701L7.50016 12.0001L6.07016 13.4101L11.6602 19.0001L23.6602 7.00008L22.2402 5.58008ZM18.0002 7.00008L16.5902 5.58008L10.2402 11.9301L11.6602 13.3401L18.0002 7.00008Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol